import { render } from "./Conpons.vue?vue&type=template&id=dd484774&scoped=true"
import script from "./Conpons.vue?vue&type=script&lang=js"
export * from "./Conpons.vue?vue&type=script&lang=js"

import "./Conpons.vue?vue&type=style&index=0&id=dd484774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd484774"]])

export default __exports__